import firebase from 'firebase';

const checkEmailExistsInFirebase = async (email: string): Promise<boolean> => {
  const signInMethods = await firebase.auth().fetchSignInMethodsForEmail(email);

  const userExists = signInMethods.length > 0 ? true : false;

  return userExists;
};

export { checkEmailExistsInFirebase };
